fx.ns("models", class ProductFrame extends  models.Creation {

	constructor(data)
	{
		super(data);

        this.product_type_id = models.ProductType.FRAME;
	}
	
    get framePage()
    {
        return this.elements.getItemAt(0);
    }

    get totalPrice()
    {
		return (this.creationOption.price_base * fx.get("lang").tax).toFixed(2) + " €" ; 
    }

    get pageWidth()
    {
        return 210;//this.creationOption.format.width;
    }

    get pageHeight()
    {
        return 300;//this.creationOption.format.height;
    }

    get format()
    {
        return this.creationOption.format;
    }

    get option()
    {
        return this.creationOption.option;
    }

    get creationOption()
    {
        return this.creationOptions.find({formatid : this.formatid, option_id : this.optionid})
    }

    get creationOptions()
    {
        return this._creationOptions;
    }

    set creationOptions(val)
    {
        this._creationOptions = val;
    }

    get borderAsset()
    {
        return fx.assets["frame" + this.option.editor_code.capitalize() + this.format.size.capitalize()];
        
        /*let borderAsset;
        switch(this.format.size)
        {
            case "small":
                borderAsset = fx.assets.woodFrameSmall;
                break;
            case "medium":
                borderAsset = fx.assets.woodFrameMedium;
                break;
            case "big":
                borderAsset = fx.assets.woodFrameBig;
                break;
        }
        return borderAsset;*/
    }

    get borderSize()
    {
        let borderSize;
        switch(this.format.size)
        {
            case "small":
                borderSize = 14;
                break;
            case "medium":
                borderSize = 11;
                break;
            case "big":
                borderSize = 9;
                break;
        }
        return borderSize;
    }  

    calculatePrice()
	{
        return this.totalPrice + " €" ;
	}

    addFrame()
    {
        let newElement = new models.ProductFramePage({creation_id : this.id, layoutid : 0});
			
		this.elements.addItem( newElement );

		newElement.addBackground();

        return newElement;
    }
});
